export const selectContactInfo = state => state.getIn(['newPerson', 'contactInfo', 'result']);

export const selectContactInfoIsLoading = state =>
  state.getIn(['newPerson', 'contactInfo', 'isLoading']);

export const selectContactInfoError = state => state.getIn(['newPerson', 'contactInfo', 'error']);
